import React from 'react';

class Post extends React.Component {
    render() {
        return <p>Post</p>;
    }
}

export default Post;